import { Component, OnInit, Input, Output, EventEmitter, HostBinding, ViewChild, OnChanges } from '@angular/core';

@Component({
  selector: 'app-layer-switcher',
  templateUrl: './map-base-layer-switcher.component.html',
  styleUrls: ['./map-base-layer-switcher.component.scss']
})
export class MapBaseLayerSwitcherComponent implements OnInit, OnChanges {
  @Input() baseLayers: Array<any> = [];
  @Input() maxHeight: number;
  @Input() @HostBinding('class.collapsible') collapsible = false;
  @Output() activate: EventEmitter<any> = new EventEmitter();

  showingSwitcher = true;

  constructor() { }

  ngOnInit() {
  }

  getBaseLayerIcon(item) {
    return `url(${item.icon})`;
  }

  activateByItem(item) {
    this.activate.emit(item);
  }

  toggleSwitcher() {
    this.showingSwitcher = !this.showingSwitcher;
  }

  onChangeSliderValue(value: [] | number, layer) {
  }

  ngOnChanges() {
  }
}
